"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7666],{

/***/ 7666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ArticleQuote; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image.module-8b345b58.mjs
var Image_module_8b345b58 = __webpack_require__(9083);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/ArticleQuote.js




const g = "article-quote", h = "article-quote__quote", q = "article-quote__name", E = "article-quote--lightBlue", L = "article-quote--lightGrey", y = "article-quote__vertical-credits", C = "article-quote__curtain-show", a = {
  articleQuote: g,
  articleQuoteQuote: h,
  articleQuoteName: q,
  articleQuoteLightBlue: E,
  articleQuoteLightGrey: L,
  articleQuoteVerticalCredits: y,
  articleQuoteCurtainShow: C
};
function x(e) {
  const { name: o, quote: u, variant: c, id: n, i18n: s } = e, { creditsLabel: m = "Credits" } = s ?? {}, d = c === "color" ? e.color === "lightGrey" ? a.articleQuoteLightGrey : a.articleQuoteLightBlue : void 0;
  return /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      id: n,
      topPadding: Block_9b78bd10.B.Padding.LARGE,
      bottomPadding: Block_9b78bd10.B.Padding.LARGE,
      className: (0,app_a75c1d35.c)(a.articleQuote, d),
      "data-testid": "article-quote"
    },
    c === "image" ? /* @__PURE__ */ react.createElement(N, { imageData: e.imageData }) : null,
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { style: { zIndex: 1 } }, /* @__PURE__ */ react.createElement(
      "blockquote",
      {
        className: (0,app_a75c1d35.c)(app_a75c1d35.t.headingSection, a.articleQuoteQuote)
      },
      u
    ), /* @__PURE__ */ react.createElement("p", { className: (0,app_a75c1d35.c)(app_a75c1d35.t.textsLeadText, a.articleQuoteName) }, o), c === "image" && e.credits ? /* @__PURE__ */ react.createElement(
      "p",
      {
        className: (0,app_a75c1d35.c)(
          a.articleQuoteVerticalCredits,
          app_a75c1d35.t.textsCaption
        )
      },
      m,
      ": ",
      e.credits
    ) : null)
  );
}
function N({
  imageData: e
}) {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
    "img",
    {
      src: e.imageLoader?.() || e.imageSrc,
      width: e.width,
      height: e.height,
      alt: "",
      "aria-hidden": "true",
      className: Image_module_8b345b58.i.imageArticleQuote
    }
  ), /* @__PURE__ */ react.createElement("div", { className: (0,app_a75c1d35.c)(a.articleQuoteCurtainShow) }));
}

//# sourceMappingURL=ArticleQuote.js.map

// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
;// CONCATENATED MODULE: ./src/magnolia/components/ArticleQuote/ArticleQuote.tsx



function ArticleQuote(node) {
    var name = node.name, quote = node.quote, background = node.background;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    if (background.field === "image") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(x, {
                quote: quote,
                name: name,
                variant: "image",
                imageData: imageDataHandler(background.image),
                credits: background.credits
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(x, {
            quote: quote,
            name: name,
            variant: "color",
            color: background.color.field
        })
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/ArticleQuote/index.ts



/***/ })

}]);